<template>
	<div class="form">
		<GuestHeading>¿Olvidaste la contraseña?</GuestHeading>
		<GuestErrors
			:class="Object.keys(errors).length > 0 ? 'd-block' : 'd-none'"
		>
			<span class="d-block" v-for="error in errors" :key="error">{{
				error[0]
			}}</span>
		</GuestErrors>
		<GuestInput v-model="email"
		:class="errors.email ? 'is-invalid':''"
		type="email" placeholder="Email" name="email" />
		<GuestButton @click.prevent="handleSubmit">Restablecer la contraseña</GuestButton>
	</div>
</template>

<script>
import GuestErrors from '../../components/GuestErrors.vue'
import GuestHeading from '../../components/GuestHeading.vue'
import GuestInput from '../../components/GuestInput.vue'
import GuestButton from '../../components/GuestButton.vue'
import { useStore } from "vuex";
import { ref } from 'vue';
import User from "@/api/User";

export default {
	name: "ForgetPassword",
	components: { GuestErrors, GuestHeading, GuestInput, GuestButton},
	setup() {
		const errors = ref({});
		const email = ref("");
		const store = useStore();
		const handleSubmit = async ()=>{
			try {
				const response = await User.resetPassword({email: email.value});
				if (response.status == 200) {
					errors.value = {};
					alert('Por favor, comprueba tu correo electrónico.')
				}else{
					errors.value = {'message':ex.response.data.message};
				}
			}catch(ex){
				if(ex.response.status == 422) 
					errors.value = ex.response.data.errors;
				else 
					errors.value = {'message':ex.response.data.message};
			};
		}

		return {
			loading: store.getters.loading,
			errors,
			email,
			handleSubmit
		};
	},
};
</script>

<style scoped>
	.form {
		position: relative;
		z-index: 1;
		background: #ffffff;
		max-width: 360px;
		padding: 45px;
		text-align: center;
		box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2), 0 5px 5px 0 rgba(0, 0, 0, 0.24);
	}
</style>
